<h2 class="heading-4">Your {{ vm.claimType }}</h2>

<p class="body mt-8">
  Sorry, online booking is not yet available for this product. We’re working to get all bookings online.<br />
  If you want to book a repair or for any help, please give us a call.
</p>

<app-telephone-link
  class="mt-8"
  [largeFont]="true"
  [phoneNumber]="vm.phone"
  [postCode]="vm.postCode"
  postCodeMessagingClasses="max-w-480"
/>
